"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const classnames_1 = __importDefault(require("classnames"));
require("../../../styles/components/icons/dropdown-arrow.less");
const DropdownArrow = ({ open, focused }) => (react_1.default.createElement("div", { className: (0, classnames_1.default)('bouncy-arrow-icon', { open, focused }) },
    react_1.default.createElement("span", { className: "left-bar" }),
    react_1.default.createElement("span", { className: "right-bar" })));
exports.default = DropdownArrow;
//# sourceMappingURL=dropdown-arrow.js.map